import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.bsBg10};
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 1px 10px rgba(168, 121, 0, 0.13)'};
  border-radius: 40px;
  width: 616px;
  overflow: hidden;
  margin-top: 12px;
  padding: 32px 0;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`
const Title = styled.div`
  color: ${({ theme }) => theme.primary1};
  margin: 0 0 26px;
  font-family: Baloo Da;
  font-size: 18px;
`
const Title1 = styled(Title)`
  margin: 32px 0 26px;
`
const ImgArtwork = styled.img`
  width: 76px;
  height: auto;
  margin-bottom: 40px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-bottom: 16px;
  `}
`
const GoArtworks = styled(NavLink)`
  display: inline-block;
  background: ${({ theme }) => theme.primary1 };
  color: ${({ theme }) => theme.bsText1 };
  border-radius: 10px;
  width: 240px;
  font-family: Baloo Da;
  font-size: 14px;
  text-decoration: none;
  line-height: 40px;
  text-align: center;
`

export default function NoArtworks({ownBtn, status, nftName}: {ownBtn?: boolean, status?: number, nftName?: string}) {
  return (
    <Wrapper>
      {
        ownBtn
          ? <Title>You don't own any {nftName ? nftName : 'nfts'}</Title>
          : !status
              ? <Title1>There is no NFT on pending</Title1>
              : <Title1>There is no NFT on sale</Title1>
      }
      <ImgArtwork src="/images/artworks/no_art.png" alt="unknown-artwork"/>
      {
        ownBtn && <GoArtworks to={'/gamification/car'}>Go to exchange</GoArtworks>
      }
    </Wrapper>
  )
}